import { useEffect, createContext } from 'react';


export const metadata = {
  "proof": "2b31dacf206363e97c00dba61fe88ea8863ad358d5f39d8716e3ea8f9fdd0e9f",
  "traitsCount": {
    "Surname": 11,
    "Background": 36,
    "Base": 36,
    "Body": 30,
    "Clothes": 47,
    "Head": 30,
    "Eyes": 31,
    "Mouth": 30,
    "Head Gear": 45,
    "Back Weapon": 31,
    "Right Hand Weapon": 26,
    "Left Hand Weapon": 28,
    "Glove & Weapon": 21
  },
  "traits": {
    "Surname": {
      "Ramborovski": 1,
      "Alienrovski": 1,
      "Monkeyrovski": 1,
      "Judgerovski": 1,
      "Kongrovski": 1,
      "Kaijurovski": 1,
      "Trooporovski": 1,
      "Robotrovski": 1,
      "Rangerovski": 1,
      "Generalrovski": 1,
      "Roborovski": 7767
    },
    "Background": {
      "Tropical Jungle": 1,
      "Alien Planet": 1,
      "Highland": 1,
      "Contaminated Factory": 1,
      "Giant Skull": 1,
      "Destroyed City": 1,
      "Alien Desert": 1,
      "Brownstone": 1,
      "Gloomy City": 1,
      "Bell Temple": 1,
      "Digital City": 233,
      "Cage": 388,
      "Petshop": 233,
      "Yellow Sun": 388,
      "Fire": 233,
      "Moon": 385,
      "Yin Yang": 388,
      "Wave": 389,
      "Factory": 234,
      "Japanese Gate": 388,
      "Bamboo": 388,
      "Red Brush": 388,
      "Village": 157,
      "Dojo": 233,
      "Colloseum": 388,
      "Dragon": 388,
      "Arena": 233,
      "Graveyard": 233,
      "Bonsai": 388,
      "Gold Castle": 388,
      "Fuji": 388,
      "Punch": 157,
      "Dark City": 158,
      "City": 155,
      "Sewer": 233,
      "Mountain": 233
    },
    "Base": {
      "Jungle Rock": 1,
      "Alien Corpse": 1,
      "Demon Copse": 1,
      "Manfunction Bot": 1,
      "Dead Trex": 1,
      "Dead Kong": 1,
      "Big Alien": 1,
      "Dead Machine": 1,
      "Giant Robot": 1,
      "Broken Car": 1,
      "Rooftop": 424,
      "Glider": 117,
      "Dead Boar": 234,
      "Rock": 388,
      "Shell": 310,
      "Dead Alligator": 234,
      "Cloud": 54,
      "Dead Wolf": 234,
      "Field": 388,
      "Dead Hamster": 234,
      "Cliff": 388,
      "Concrete Rubbles": 388,
      "Dead Hyena": 234,
      "Trash": 69,
      "Dead Fish": 234,
      "Dead Snake": 234,
      "Hay": 388,
      "Graveyard": 388,
      "Rubble": 388,
      "Wood": 388,
      "Dead Iguana": 310,
      "Tower": 420,
      "Grass": 388,
      "Bridge": 157,
      "Ruin": 388,
      "Battlefield": 388
    },
    "Body": {
      "Soldier Body": 1,
      "Alien Body": 1,
      "Monkey Fur": 1,
      "Cop Body": 1,
      "Kong Fur": 1,
      "Kaiju Skin": 1,
      "Troop Body": 1,
      "Robot Body": 1,
      "Ranger Body": 1,
      "General Body": 1,
      "Pink": 388,
      "White": 622,
      "Zombie": 235,
      "Maroon": 390,
      "Cheetah": 389,
      "Light Brown": 622,
      "Camo": 622,
      "Teal": 389,
      "Dark Grey": 612,
      "Rainbow": 389,
      "Muscle": 389,
      "Gold": 71,
      "Tiger": 389,
      "Grey": 615,
      "Mummy": 172,
      "Dark Brown": 390,
      "Mutant": 233,
      "Mustard": 389,
      "Creme": 389,
      "Liquid Metal": 72
    },
    "Clothes": {
      "Solider Suit": 1,
      "Alien Suit": 1,
      "Monkey Armor": 1,
      "Cop Suit": 1,
      "Kong Suit": 1,
      "Kaiju Suit": 1,
      "Troop Suit": 1,
      "Robot Suit": 1,
      "Ranger Suit": 1,
      "General Suit": 1,
      "None": 2718,
      "Masked Hero": 61,
      "Black Pants": 103,
      "Blue Samurai": 152,
      "Red Jacket": 152,
      "Orange Clan": 46,
      "Tactical": 46,
      "White Karate": 202,
      "Black Coat": 149,
      "Yellow Jumpsuit": 265,
      "Orange Ninja": 46,
      "White Suit": 202,
      "Green Jumpsuit": 152,
      "Black Ninja": 101,
      "Bleeding Claw": 152,
      "Kungfu Student": 151,
      "Red Samurai": 151,
      "Ethnic": 152,
      "Samurai Armor": 46,
      "Red Fighter": 152,
      "Superhero": 46,
      "Ranger": 151,
      "Monk": 101,
      "Green Jersey": 101,
      "Black Karate": 151,
      "Red Karate": 203,
      "Cyborg Jacket": 151,
      "Muay Thai": 151,
      "Navy Coat": 101,
      "Kungfu Master": 151,
      "Black Shorts": 150,
      "Shirt": 252,
      "Apocalyptic": 152,
      "Red Jumpsuit": 101,
      "Gladiator": 152,
      "Bloody Shirt": 202,
      "Wrestler": 252
    },
    "Head": {
      "Soldier Head": 1,
      "Alien Head": 1,
      "Monkey Head": 1,
      "Cop Head": 1,
      "Kong Head": 1,
      "Kaiju Head": 1,
      "Troop Head": 1,
      "Robot Head": 1,
      "Ranger Head": 1,
      "General Head": 1,
      "Pink": 388,
      "White": 622,
      "Zombie": 235,
      "Maroon": 390,
      "Cheetah": 389,
      "Light Brown": 622,
      "Camo": 622,
      "Teal": 389,
      "Dark Grey": 612,
      "Rainbow": 389,
      "Muscle": 389,
      "Gold": 71,
      "Tiger": 389,
      "Grey": 615,
      "Mummy": 172,
      "Dark Brown": 390,
      "Mutant": 233,
      "Mustard": 389,
      "Creme": 389,
      "Liquid Metal": 72
    },
    "Eyes": {
      "Soldier Eyes": 1,
      "Alien Eyes": 1,
      "Monkey Eyes": 1,
      "Cop Eyes": 1,
      "Kong Eyes": 1,
      "Kaiju Eyes": 1,
      "Troop Eyes": 1,
      "Robot Eyes": 1,
      "Ranger Eyes": 1,
      "General Eyes": 1,
      "Angry": 543,
      "Scar Top Nose": 388,
      "Star Pupil": 70,
      "Both Eyes Shut": 233,
      "Machina": 311,
      "Zombie": 311,
      "Cyborg": 235,
      "Left Eye Scar": 543,
      "Upset": 545,
      "Right Eye Swollen": 388,
      "Slime": 70,
      "X Shape Scars": 467,
      "Tattooed Face": 696,
      "One Eye Slashed": 388,
      "Left Eye Swollen": 388,
      "Determined": 544,
      "Right Eye Scar": 544,
      "One Eye Shut": 428,
      "Cynical": 388,
      "Lightning": 54,
      "Rainbow": 233
    },
    "Mouth": {
      "Soldier Mouth": 1,
      "Alien Mouth": 1,
      "Monkey Mouth": 1,
      "Cop Mouth": 1,
      "Kong Mouth": 1,
      "Kaiju Mouth": 1,
      "Troop Mouth": 1,
      "Robot Mouth": 1,
      "Ranger Mouth": 1,
      "General Mouth": 1,
      "Joker": 56,
      "Smug": 544,
      "Bleeding": 71,
      "Whistle": 544,
      "Tongue Out": 621,
      "Two Teeth": 700,
      "X Scar": 544,
      "Cowboy Moustache": 233,
      "White Beard": 388,
      "Thick Moustache": 280,
      "Scream": 696,
      "Scary Teeth": 70,
      "Three Scars": 545,
      "Closed": 388,
      "Zombie": 70,
      "Open": 698,
      "Norse Beard": 388,
      "Richman Moustache": 155,
      "Cat Moustache": 311,
      "Swollen": 465
    },
    "Head Gear": {
      "Soldier Headband": 1,
      "Alien Helmet": 1,
      "Monkey Crown": 1,
      "Cop Helmet": 1,
      "Kong Helmet": 1,
      "Kaiju Helmet": 1,
      "Troop Helmet": 1,
      "Robot Helmet": 1,
      "Ranger Helmet": 1,
      "General Hat": 1,
      "None": 3107,
      "Hero Mask": 93,
      "Bandana": 93,
      "Tactical Helmet": 93,
      "Ninja Headband": 234,
      "Mouth Mask": 93,
      "Red Mask": 233,
      "White Mask": 93,
      "Metal Mask": 93,
      "Eye Patch": 139,
      "Ninja Mask": 187,
      "White Headband": 233,
      "Blue Mask": 93,
      "Red Sunglasses": 93,
      "Goggle": 93,
      "Classic Hat": 42,
      "Mohawk": 234,
      "Spy Sunglasses": 188,
      "Old Hat": 65,
      "Red Headband": 140,
      "Gas Mask": 140,
      "Samurai Helmet": 93,
      "Balaclava": 93,
      "Pompadour": 140,
      "Viking Helmet": 93,
      "Head Sign": 93,
      "Black Sunglasses": 233,
      "Bald Head": 140,
      "Spike Hair": 94,
      "Wrestler": 93,
      "VR": 33,
      "Blood": 416,
      "Samurai Hair": 140,
      "Gladiator Helmet": 139,
      "Red Cap": 188
    },
    "Back Weapon": {
      "Vintage Launcher": 1,
      "Alien Laser": 1,
      "Monkey Cape": 1,
      "Cop Canon": 1,
      "Kong Back": 1,
      "Kaiju Tail": 1,
      "Troop Bazooka": 1,
      "Robot Canon": 1,
      "Ranger Energy": 1,
      "General Cape": 1,
      "None": 5049,
      "Long Bow": 136,
      "Sniper": 163,
      "Short Bow": 136,
      "Tanto": 136,
      "Ancient Katana": 163,
      "Wakizachi": 134,
      "Big Sword": 190,
      "Katana": 163,
      "Sword": 136,
      "Kanabo": 136,
      "Guitar Rifle": 82,
      "Shotgun": 136,
      "Rocket Launcher": 19,
      "Twin Blade": 189,
      "Kunai": 164,
      "Ono Axe": 165,
      "Scythe": 164,
      "Long Sword": 147,
      "Shell": 24,
      "Bat": 135
    },
    "Right Hand Weapon": {
      "Soldier Hand": 1,
      "Alien Trident": 1,
      "Monkey Staff": 1,
      "Cop Blaster": 1,
      "Hostage Lady": 1,
      "Military Tank": 1,
      "Troop Blaster": 1,
      "Robot Blaster": 1,
      "Ranger Sword": 1,
      "General Arm": 1,
      "Palm": 3107,
      "Scimitar": 350,
      "Flute": 54,
      "Trident": 70,
      "Roman Sword": 312,
      "Neko Te": 311,
      "Naginata": 348,
      "Medieval Sword": 342,
      "Tonfa": 233,
      "Chakram": 233,
      "Nunchuck": 541,
      "Hammer": 389,
      "Toothpick": 544,
      "Long Katana": 389,
      "Space Gun": 156,
      "Kusarigama": 388
    },
    "Left Hand Weapon": {
      "Soldier Gatling Gun": 1,
      "Alien Tentacle": 1,
      "Monkey Gauntlet": 1,
      "Cop Double Blaster": 1,
      "Kong Palm": 1,
      "Chopper": 1,
      "Troop Flame": 1,
      "Robot Gun": 1,
      "Ranger Palm": 1,
      "General Metal Hand": 1,
      "Bare Hand": 2720,
      "Falcon": 61,
      "Bomb": 392,
      "Hook": 267,
      "Metal Claw": 389,
      "Kungfu Palm": 59,
      "Stopping Bullets": 469,
      "Fantasy Shield": 268,
      "Gunblade": 267,
      "Flame Thrower": 491,
      "Whip": 267,
      "Gladiator Shield": 316,
      "Rocket Punch": 367,
      "Gauntlet": 166,
      "Cannon": 266,
      "Tri Claws": 367,
      "Kunai Spear": 469,
      "Rings": 166
    },
    "Glove & Weapon": {
      "Soldier Glove": 1,
      "Alien Glove": 1,
      "Monkey Glove": 1,
      "Cop Glove": 1,
      "Kong Glove": 1,
      "Kaiju Glove": 1,
      "Troop Glove": 1,
      "Robot Glove": 1,
      "Ranger Glove": 1,
      "General Glove": 1,
      "None": 4971,
      "Pistol": 139,
      "Uzi": 224,
      "Crossbow": 336,
      "Shotgun": 336,
      "Space Gun": 279,
      "Phaser Gun": 139,
      "Gun": 335,
      "Carabine Rifle": 336,
      "Silver Gun": 336,
      "Golden Gun": 336
    }
  },
  "tokens": []
};
